import React from "react"
import { Route, Routes, Navigate } from "react-router-dom"
import LearnLayout from "./layout/LearnLayout"
import RequireStudent from "./layout/RequireStudent"
import StudentAuth from "./pages/StudentAuth"
import LearnHomePage from "./pages/LearnHomePage"
import MyCoursesPage from "./pages/MyCoursesPage"
import CourseDetailPage from "./pages/CourseDetailPage"
import LecturePlayerPage from "./pages/LecturePlayerPage"
import PageNotFound from "../NonRoure"

/**
 * The lecture portal's entire route tree, mounted at /learn.
 *
 * It is registered as a splat route in Routeing.js so the portal is reachable
 * whether or not a staff user is signed in -- students authenticate here with
 * their own session, independently of the staff and public route trees.
 */
export default function LectureRoutes() {
    return (
        <Routes>
            <Route index element={<Navigate to="home" replace />} />

            <Route path="auth">
                <Route index element={<Navigate to="login" replace />} />
                <Route path="login" element={<StudentAuth mode="login" />} />
                <Route path="signup" element={<StudentAuth mode="signup" />} />
            </Route>

            <Route
                element={
                    <RequireStudent>
                        <LearnLayout />
                    </RequireStudent>
                }
            >
                <Route path="home" element={<LearnHomePage />} />
                <Route path="my-courses" element={<MyCoursesPage />} />
                <Route path="course/:course_id" element={<CourseDetailPage />} />
                <Route
                    path="course/:course_id/lecture/:lecture_id"
                    element={<LecturePlayerPage />}
                />
            </Route>

            <Route path="*" element={<PageNotFound />} />
        </Routes>
    )
}
